/* eslint-disable ember/no-computed-properties-in-native-classes, ember/require-computed-property-dependencies */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type Person from 'linced-app/models/person';

// Proto: attendance.DayCode.
export default class DayCode extends Model {
  declare [Type]: 'attendance/day-code';

  @belongsTo('person', { async: true, inverse: null })
  declare personId: AsyncBelongsTo<Person>;

  @alias('personId')
  declare person: AsyncBelongsTo<Person>;

  @alias('person.id')
  declare person_id: string | null | undefined;

  @attr({ defaultValue: () => ({}) })
  declare counts: Record<string, number>;

  @attr('number', { defaultValue: 0 })
  declare lateCount: number;

  // partialAbsences indicate absences >= 120 minutes
  @attr('number', { defaultValue: 0 })
  declare partialAbsences: number;

  // minorPartialAbsences indicate absences < 120 minutes
  @attr('number', { defaultValue: 0 })
  declare minorPartialAbsences: number;

  @computed('counts')
  get present() {
    // TS-BUG: counts can omit a code, so present is undefined and total is
    // NaN.
    return this.counts.P!;
  }

  @computed('counts')
  get absent() {
    // TS-BUG: counts can omit a code, so absent is NaN.
    return this.counts.U! + this.counts.J!;
  }

  @computed('absent')
  get absentWholeDays() {
    return this.absent / 2;
  }

  @computed('absent', 'present')
  get total() {
    return this.present + this.absent;
  }

  @computed('absent', 'present', 'total')
  get presentPercentage() {
    return this.total > 0
      ? ((this.present / this.total) * 100).toFixed(1)
      : '0.0';
  }

  @computed('absent', 'present', 'total')
  get absentPercentage() {
    return this.total > 0
      ? ((this.absent / this.total) * 100).toFixed(1)
      : '0.0';
  }
}
